export { RegistrationBtn } from './registration-btn';
export {RegistrationForm} from './registration-form'